<script lang="ts" setup>
import type { CompanyItem } from '~/models/Company'

// combined models for prismic field & company item
interface CombinedField {
  url?: string
  image?: { url: string }
  openinnewtab?: string
  title?: any
  title_position?: string
  subtitle?: any
  subtitle_position?: string
  name?: string | string[]
  slug?: string
  thumbnail?: string
}

interface Props {
  item: CombinedField
  source?: string
}

const props = defineProps<Props>()
const localePath = useLocalePath()
</script>

<template>
  <div class="relative block">
    <NuxtLink :to="localePath(props.item?.url ? props.item?.url : (props.item?.thumbnail_url ? props.item?.thumbnail_url : `/companies/${props.item?.slug}`))" :target="props.item?.openinnewtab ? '_blank' : ''">
      <img :src="props.item?.thumbnail?.data?.attributes?.url || props.item?.thumbnail || props.item?.image?.url" class="object-cover rounded-md border border-gray-100">
    </NuxtLink>
    <NuxtLink v-if="!isEmpty(props.item?.name || props.item?.title)" :to="localePath(props.item?.url ? props.item?.url : (props.item?.thumbnail_url ? props.item?.thumbnail_url : `/companies/${props.item?.slug}`))" :target="props.item?.openinnewtab ? '_blank' : ''">
      <p :class="`${props.source === 'prismic' ? 'text-xs md:text-base' : 'text-xs md:text-sm'} font-semibold mt-2 truncate text-${props.item?.title_position || 'left'}`">
        {{ props.item?.name || props.item?.title || props.item?.title[0]?.text }}
      </p>
    </NuxtLink>
    <p v-if="!isEmpty(props.item?.subtitle)" :class="`text-${props.item?.subtitle_position ? props.item?.subtitle_position : 'left'} line-clamp-2`">
      {{ props.item?.subtitle || props.item?.subtitle[0]?.text }}
    </p>
  </div>
</template>
